import { Component, OnInit, OnDestroy, Input, HostListener, ElementRef, Output, EventEmitter, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser } from "@angular/common";
import { UserList } from '../../../_models/user.model';
import { MenuStateService } from '../../../_services/app/menu-state.service';
import { Router } from '@angular/router';
import { AdminUserService } from '../../../_services/api/admin-user.service';
import { NotificationService } from '../../../_services/app/notification.service';

@Component({
  selector: 'app-admin-member-card',
  imports: [CommonModule],
  templateUrl: './admin-member-card.html',
  styleUrl: './admin-member-card.scss',
})
export class AdminMemberCard implements OnInit, OnDestroy {
  @Input() member!: UserList;
  @Output() memberUpdated = new EventEmitter<void>();
  @Output() memberDeleted = new EventEmitter<void>();
  
  menuOpen = false;
  showDeleteModal = false;
  isUpdatingVisibility = false;

  constructor(
    private menuStateService: MenuStateService,
    private notification: NotificationService,
    private elementRef: ElementRef,
    private router: Router,
    private userService: AdminUserService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    this.menuStateService.activeMenu$.subscribe(activeId => {
      this.menuOpen = activeId === this.member.id;
    });
    if (isPlatformBrowser(this.platformId)) {
        document.addEventListener('click', this.closeMenu.bind(this));
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
        document.removeEventListener('click', this.closeMenu.bind(this));
    }
  }

  toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    if (this.menuOpen) {
      this.menuStateService.setActiveMenu(null);
    } else {
      this.menuStateService.setActiveMenu(this.member.id);
    }
  }

  @HostListener('document:click', ['$event'])
  closeMenu(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.menuOpen = false;
    }
    if (this.menuOpen) {
      this.menuStateService.setActiveMenu(null);
    }
  }

  setDefaultImage(event: any): void {
    event.target.src = './assets/images/user-default.png';
  }

  toggleVisibility(): void {
    if (this.isUpdatingVisibility) return;
    
    this.isUpdatingVisibility = true;
    this.menuStateService.setActiveMenu(null);
    this.menuOpen = false;
    
    if (this.member.isEnabled) {
      this.userService.disableUser(this.member.id).subscribe({
        next: () => {
          this.member.isEnabled = false;
          this.memberUpdated.emit();
          this.isUpdatingVisibility = false;
          this.notification.showSuccess("Le membre est maintenant désactivé et n’a plus accès à la plateforme.");
        },
        error: (error) => {
          console.error('Error making member disabled:', error);
          this.isUpdatingVisibility = false;
          this.notification.showError('Erreur lors de la modification de la visibilité');
        }
      });
    } else {
      this.userService.enableUser(this.member.id).subscribe({
        next: () => {
          this.member.isEnabled = true;
          this.memberUpdated.emit();
          this.isUpdatingVisibility = false;
          this.notification.showSuccess("Le membre est maintenant actif et peut de nouveau accéder à la plateforme.");
        },
        error: (error) => {
          console.error('Error making member enabled:', error);
          this.isUpdatingVisibility = false;
          this.notification.showError('Erreur lors de la modification de la visibilité');
        }
      });
    }
  }

  details(){
    this.router.navigate(['/admin/clients/details', this.member.id]);
  }

  edit(){
    this.router.navigate(['/admin/clients/edit', this.member.id]);
  }

  confirmDelete(): void {
    this.menuOpen = false;
    this.showDeleteModal = true;
  }

  closeDeleteModal(): void {
    this.showDeleteModal = false;
  }

  deleteMember(): void {
    this.userService.deleteUser(this.member.id).subscribe({
      next: () => {
        this.showDeleteModal = false;
        this.memberDeleted.emit();
      },
      error: (error) => {
        console.error('Error deleting membre:', error);
        this.notification.showError('Erreur lors de la suppression du member');
        this.showDeleteModal = false;
      }
    });
  }
}
